export default __webpack_public_path__ + "static/header-types-light-a2c772e18c0f13a3f5145dcade476adca26da7476087dbe45d5bf782e8513556.png";